
import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: 'easeOut' }}
          className="fixed bottom-0 left-0 right-0 w-full z-50 bg-[#0B3A2A] border-t border-[#7CFF6B]/20 shadow-lg"
        >
          <div className="w-full px-4 sm:px-6 lg:px-8 py-4">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <div className="flex items-start gap-3 flex-1">
                <div className="w-10 h-10 flex items-center justify-center text-[#FFD400] flex-shrink-0">
                  <i className="ri-cookie-line ri-xl"></i>
                </div>
                <p className="text-[#F3FFF9] text-sm leading-relaxed">
                  Utilizamos cookies propias y de terceros para mejorar tu experiencia de navegación, 
                  analizar el tráfico del sitio y personalizar el contenido. Al hacer clic en "Aceptar", 
                  consientes el uso de todas las cookies. Puedes rechazarlas o consultar nuestra{' '}
                  <Link 
                    to="/politica-cookies" 
                    className="text-[#FFD400] hover:text-[#7CFF6B] underline transition-colors"
                  >
                    política de cookies
                  </Link>{' '}
                  para más información.
                </p>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <button
                  onClick={handleReject}
                  className="px-5 py-2.5 text-sm font-medium text-[#F3FFF9] border border-[#F3FFF9]/30 rounded-lg hover:bg-[#F3FFF9]/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Rechazar
                </button>
                <button
                  onClick={handleAccept}
                  className="px-5 py-2.5 text-sm font-medium bg-[#FFD400] text-[#062A1E] rounded-lg hover:bg-[#7CFF6B] hover:shadow-[0_0_20px_rgba(255,212,0,0.3)] transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Aceptar cookies
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
